import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const NoticePage = () => {
  const { id } = useParams();
  const [notice, setNotice] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetch("https://deoria.ilakshyaerp.in/api/notices")
      .then((res) => res.json())
      .then((data) => {
        const selected = data.find((n) => n.id === Number(id));
        setNotice(selected);
      });
  }, [id]);

  if (!notice) return <h2>Loading...</h2>;

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />
      <Sidebar isOpen={open} close={() => setOpen(false)} />
      <main className="page-wrapper">
        <div className="notice-header">
          <h2>NOTICE</h2>
        </div>

        <div className="notice-detail">

          <h1>{notice.title}</h1>
          <p>{notice.content}</p>

        </div>
      </main>
      <Footer />
    </>
  );
};

export default NoticePage;